<template lang="pug">
  .bcard-btnbar.form-control-static.pull-left
    a(href="#" @click.prevent="modalSearch = true" data-testid="link-advanced-search") 詳細検索
    |
    |
    a(v-if="conditions._searched" href="#" @click.prevent="clear" title="検索条件をクリアする"): i.fa.bcard-fa-filter-clear.fa-lg

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    portal(to="modal")
      form(@submit.prevent="submit")
        app-modal(type="info" :size="isTwoColumns() ? 'xlarge' : ''" v-model="modalSearch", data-testid="modal-search")
          template(slot="title") 詳細条件
          div(:class="{row: isTwoColumns()}")
            div(:class="{'col-md-6': isTwoColumns()}")
              .form-group(v-if="isIncludes(show, 'name')")
                label(for="search_name") 氏名
                input.form-control#search_name(type="text", v-model="conditions.name", name="search_name" data-testid="search_name" placeholder="氏名、氏名（よみがな）を前方一致で検索します")

              .form-group(v-if="isIncludes(show, 'corporate_name')")
                label(for="search_corporate_name") 会社名
                input.form-control#search_corporate_name(type="text", v-model="conditions.corporate_name", name="search_corporate_name" data-testid="search_corporate_name" placeholder="会社名、会社名（よみがな）を部分一致で検索します")

              .form-group(v-if="isIncludes(show, 'dept_post')")
                label(for="search_dept_post") 部署名/役職
                input.form-control#search_dept_post(type="text", v-model="conditions.dept_post", name="search_dept_post" data-testid="search_dept_post" placeholder="部署名、役職、部署名＋役職を部分一致で検索します")

              .form-group(v-if="isIncludes(show, 'zipcode')")
                label(for="search_zipcode") 郵便番号
                input.form-control#search_zipcode(type="text", v-model="conditions.zipcode", name="search_zipcode" data-testid="search_zipcode" placeholder="郵便番号を部分一致で検索します")
                .help-block
                  .bcard-comments.text-info ※ 事業所1、事業所2の情報を検索対象とします。

              .form-group(v-if="isIncludes(show, 'address')")
                label(for="search_address") 住所
                input.form-control#search_address(type="text", v-model="conditions.address", name="search_address" data-testid="search_address" placeholder="住所1、住所2を部分一致で検索します")
                .help-block
                  .bcard-comments.text-info ※ 事業所1、事業所2の情報を検索対象とします。

              .form-group(v-if="isIncludes(show, 'tel')")
                label(for="search_tel") 電話番号
                input.form-control#search_tel(type="text", v-model="conditions.tel", name="search_tel" data-testid="search_tel" placeholder="電話番号1、電話番号2、携帯電話を部分一致で検索します")
                .help-block
                  .bcard-comments.text-info ※ 数字を入力してください。
                  .bcard-comments.text-info ※ 事業所1、事業所2の情報を検索対象とします。

              .form-group(v-if="isIncludes(show, 'fax')")
                label(for="search_fax") FAX
                input.form-control#search_fax(type="text", v-model="conditions.fax", name="search_fax" data-testid="search_fax" placeholder="FAXを部分一致で検索します")
                .help-block
                  .bcard-comments.text-info ※ 数字を入力してください。
                  .bcard-comments.text-info ※ 事業所1、事業所2の情報を検索対象とします。

              .form-group(v-if="isIncludes(show, 'mail')")
                label(for="search_mail") メールアドレス
                input.form-control#search_mail(type="text", v-model="conditions.mail", name="search_mail" data-testid="search_mail" placeholder="メールアドレスを部分一致で検索します")
                .help-block
                  .bcard-comments.text-info ※ 事業所1、事業所2の情報を検索対象とします。

              .form-group(v-if="isIncludes(show, 'memo')")
                label(for="search_memo") メモ
                input.form-control#search_memo(type="text", v-model="conditions.memo", name="search_memo" data-testid="search_memo" placeholder="共有メモ、個人メモを部分一致で検索します")

              .form-group(v-if="isIncludes(show, 'keywords')")
                label(for="search_keywords") 検索キーワード
                input.form-control#search_keywords(type="text", v-model="conditions.keywords", name="search_keywords" data-testid="search_keywords" placeholder="検索キーワードを部分一致で検索します")

            div(:class="{'col-md-6': isTwoColumns()}")
              .form-group(v-if="isIncludes(show, 'openflag')")
                openflag-field(v-model="conditions.openflag", type="checkbox", @input="")

              .form-group(v-if="isIncludes(show, 'tags')")
                label タグ
                sel-tags(v-model="conditions.tags", :view_mode="false", :mode="{isDispPv: !isMgmt, canAddPv: false, isEdit: false}")
                .help-block
                  p.bcard-comments.text-info ※ 選択したタグのいずれかを含む名刺を検索します。

              hr(v-if="isIncludes(show, 'tags')")

              .form-group(v-if="isIncludes(show, 'exchange_date_from') || isIncludes(show, 'exchange_date_to')")
                label 名刺交換日
                .input-group
                  date-picker.form-control(
                    v-if="isIncludes(show, 'exchange_date_from')",
                    name="exchange_date_from",
                    v-model="conditions.exchange_date_from",
                    data-testid="-input-exdate-from"
                  )
                  span.input-group-addon ～
                  date-picker.form-control(
                    v-if="isIncludes(show, 'exchange_date_to')",
                    name="exchange_date_to",
                    v-model="conditions.exchange_date_to",
                    data-testid="-input-exdate-to"
                  )

              .form-group(v-if="isIncludes(show, 'exchangers')")
                label 名刺交換者
                template(v-if="isMgmt")
                  .radio.radio-rich
                    label.radio-inline(data-testid="-radio-ghost_exchangers")
                      input(type="radio" name="ghost_exchangers" v-model="conditions.ghost_exchangers" value="2")
                      span: i.fa.fa-dot-circle-o.fa-lg
                      | 交換者が「システム設定ユーザー」のみの名刺を検索する
                  .radio.radio-rich
                    label.radio-inline(data-testid="-radio-ghost_exchangers")
                      input(type="radio" name="ghost_exchangers" v-model="conditions.ghost_exchangers" value="1")
                      span: i.fa.fa-dot-circle-o.fa-lg
                      | 削除されたユーザーが交換した名刺を検索する
                  .radio.radio-rich
                    label.radio-inline(data-testid="-radio-ghost_exchangers")
                      input(type="radio" name="ghost_exchangers" v-model="conditions.ghost_exchangers" value="0")
                      span: i.fa.fa-dot-circle-o.fa-lg
                      | 選択したユーザーのいずれかが交換した名刺を検索する

                sel-users(
                  v-if="conditions.ghost_exchangers === app_flag.OFF",
                  v-model="conditions.exchangers",
                  :getDels="true",
                  :view_mode="false"
                )

              p(v-if="hasCollapsedExchangeFields()")
                a(href="#jbcard-collapse-exchange" data-toggle="collapse" aria-expanded="false" aria-controls="jbcard-collapse-exchange" data-testid="-link-view-exchange") その他の交換時情報
                  |
                  |
                  i.fa.fa-caret-down
                  i.fa.fa-caret-up

              #jbcard-collapse-exchange.collapse(v-if="hasCollapsedExchangeFields()")
                .form-group(v-if="isIncludes(show, 'ex_location')")
                  label(for="search_ex_location") 交換場所
                  input.form-control#search_ex_location(type="text", v-model="conditions.ex_location", name="search_ex_location" data-testid="search_ex_location" placeholder="交換場所、交換場所詳細を部分一致で検索します")

                .form-group(v-if="isIncludes(show, 'ex_trigger')")
                  label(for="search_ex_trigger") きっかけ
                  input.form-control#search_ex_trigger(type="text", v-model="conditions.ex_trigger", name="search_ex_trigger" data-testid="search_ex_trigger" placeholder="きっかけ、きっかけ詳細を部分一致で検索します")

                .form-group(v-if="isIncludes(show, 'in_introducer')")
                  label 社内紹介者
                  sel-users(
                    v-model="conditions.in_introducer",
                    :view_mode="false"
                  )
                  .help-block
                    p.bcard-comments.text-info ※ 選択した社内紹介者のいずれかを含む名刺を検索します。

                .form-group(v-if="isIncludes(show, 'out_introducer')")
                  label 社外紹介者
                  sel-persons(
                    v-model="conditions.out_introducer",
                    :view_mode="false"
                  )
                  .help-block
                    p.bcard-comments.text-info ※ 選択した社外紹介者のいずれかを含む名刺を検索します。

                .form-group(v-if="isIncludes(show, 'age')")
                  label 年代
                  select.form-control(v-model="conditions.age" data-testid="-select-age")
                    option(value="", selected) (未指定)
                    option(value="10") 10 代
                    option(value="20") 20 代
                    option(value="30") 30 代
                    option(value="40") 40 代
                    option(value="50") 50 代
                    option(value="60") 60 代
                    option(value="70") 70 代 以上

              hr(v-if="isIncludes(show, 'search_target_opt')")

              .form-group(v-if="isIncludes(show, 'search_target_opt')")
                label 検索対象
                .radio.radio-rich(v-for="(option, key) in searchTargetOptions")
                  label.radio-inline(data-testid="search-target-opt")
                    input(type="radio" name="search_target_opt" v-model="conditions.search_target_opt" :value="key")
                    span: i.fa.fa-dot-circle-o.fa-lg
                    | {{option}}

              hr(v-if="isIncludes(show, 'display_mode')")

              .form-group(v-if="isIncludes(show, 'display_mode')")
                label 表示内容の切り替え
                .radio.radio-rich
                  label.radio-inline(data-testid="radio-display-latest")
                    input(type="radio" name="display_mode" v-model="conditions.display_mode" value="0")
                    span: i.fa.fa-dot-circle-o.fa-lg
                    | 最新の名刺情報を表示
                .radio.radio-rich
                  label.radio-inline(data-testid="radio-display-all")
                    input(type="radio" name="display_mode" v-model="conditions.display_mode" value="1")
                    span: i.fa.fa-dot-circle-o.fa-lg
                    | 検索に該当した名刺情報を表示

          template(slot="footer" slot-scope="{close}")
            button.btn.btn-primary(type="submit", data-testid="-btn-search") 検索
            button.btn.btn-default(type="button" @click.prevent="close" data-testid="-btn-cancel") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import OpenflagField from '@/components/molecules/OpenflagField'
import SelTags from '@/components/organisms/SelTags'
import SelUsers from '@/components/organisms/SelUsers'
import SelPersons from '@/components/organisms/SelPersons'
import DatePicker from '@/components/molecules/DatePicker'

const defaultConditions = {
  name: '',
  corporate_name: '',
  dept_post: '',
  zipcode: '',
  address: '',
  tel: '',
  fax: '',
  mail: '',
  memo: '',
  keywords: '',
  openflag: ['0', '1'], // default: 両選択
  tags: [],
  exchange_date_from: '',
  exchange_date_to: '',
  exchangers: [],
  ghost_exchangers: '0',
  ex_location: '',
  ex_trigger: '',
  in_introducer: [],
  out_introducer: [],
  age: '',
  /**
   * 普通の一覧
   * '0': 自分が交換した名刺
   * '1': すべての名刺
   * 名刺画像未登録一覧
   * '0': 自分が最新の名刺交換者である名刺
   * '1': 自分が登録した名刺すべて
   */
  search_target_opt: '0',
  /**
   * '0': 最新の名刺情報を表示
   * '1': 検索に該当した名刺情報を表示
   */
  display_mode: '0'
}

export default {
  name: 'FuncAdvancedSearch',
  components: { AppModal, OpenflagField, SelTags, SelUsers, SelPersons, DatePicker },
  props: {
    /**
     * conditions
     */
    value: { type: Object, required: true },
    /**
     * リセット用conditions
     */
    init: { type: Object, required: true },
    show: {
      type: Array,
      required: false,
      default () {
        return [
          'name',
          'corporate_name',
          'dept_post',
          'zipcode',
          'address',
          'tel',
          'fax',
          'mail',
          'memo',
          'keywords',
          'openflag',
          'tags',
          'exchange_date_from',
          'exchange_date_to',
          'ex_location',
          'ex_trigger',
          'in_introducer',
          'out_introducer',
          'age',
          'display_mode'
        ]
      }
    },
    searchTargetOptions: {
      type: Object,
      required: false,
      default () {
        /**
         * 普通の一覧
         * '0': 自分が交換した名刺
         * '1': すべての名刺
         * 名刺画像未登録一覧
         * '0': 自分が最新の名刺交換者である名刺
         * '1': 自分が登録した名刺すべて
         */
        return {
          '0': '自分が交換した名刺',
          '1': 'すべての名刺'
        }
      }
    }
  },
  data: function () {
    return {
      modalSearch: false,
      conditions: {},
      initConditions: null // リセットするときに使う
    }
  },
  watch: {
    /**
     * clear()で親のcondsが更新された後など
     */
    value () {
      this.initConds()
    }
  },
  created () {
    this.initConds()
  },
  methods: {
    initConds () {
      this.initConditions = this._filterConds(this.init)
      this.conditions = this._filterConds(this.value)
      this.conditions._searched = this.value._searched // storeに保存したいのでconditionsの中に入れる
    },
    _filterConds (value) {
      let conds = {}
      for (let field of this.show) {
        conds[field] = (field in value) ? value[field] : defaultConditions[field]
      }
      return conds
    },
    isTwoColumns () {
      return (
        this.isIncludes(this.show, 'name') ||
        this.isIncludes(this.show, 'corporate_name') ||
        this.isIncludes(this.show, 'dept_post') ||
        this.isIncludes(this.show, 'zipcode') ||
        this.isIncludes(this.show, 'address') ||
        this.isIncludes(this.show, 'tel') ||
        this.isIncludes(this.show, 'fax') ||
        this.isIncludes(this.show, 'mail') ||
        this.isIncludes(this.show, 'memo') ||
        this.isIncludes(this.show, 'keywords')
      ) && (
        this.isIncludes(this.show, 'openflag') ||
        this.isIncludes(this.show, 'tags') ||
        this.isIncludes(this.show, 'exchange_date_from') ||
        this.isIncludes(this.show, 'exchange_date_to') ||
        this.isIncludes(this.show, 'ex_location') ||
        this.isIncludes(this.show, 'ex_trigger') ||
        this.isIncludes(this.show, 'in_introducer') ||
        this.isIncludes(this.show, 'out_introducer') ||
        this.isIncludes(this.show, 'age') ||
        this.isIncludes(this.show, 'display_mode')
      )
    },
    hasCollapsedExchangeFields () {
      return (
        this.isIncludes(this.show, 'ex_location') ||
        this.isIncludes(this.show, 'ex_trigger') ||
        this.isIncludes(this.show, 'in_introducer') ||
        this.isIncludes(this.show, 'out_introducer') ||
        this.isIncludes(this.show, 'age')
      )
    },
    submit () {
      this.modalSearch = false
      this.conditions._searched = true
      this.$emit('search', {
        page: { page: 1 },
        conds: this.conditions
      })
    },
    /**
     * 検索条件をクリアして一覧を再読み込みする
     */
    clear () {
      this.$emit('search', { conds: this.initConditions })
    }
  }
}
</script>

<style lang="scss" scoped>
.bcard-btnbar.pull-left {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/functions/FuncAdvancedSearch.vue